import ExtendableError from 'ContentData/models/ExtendableError';
export default class ValidationError extends ExtendableError {
  constructor(message) {
    super(message);
    this.message = message;
    this.stack = '';
  }
}